import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { get, isEqual } from "lodash";
import reducer from "./reducer";
import {
  passcodeSubmit,
  resendCode,
  rememberDevice,
  mfaSuccessMessage,
} from "./actions";
import { passcodeSubmit as submitPasscode } from "../VerifyPasscode/actions";
import { resendPasscode } from "../Login/actions";
import {
  Input,
  CardContent,
  Heading,
  Content,
  HEADING_TYPES,
  HEADING_LEVELS,
  INPUT_SIZES,
  PrimaryButton,
  Toast,
  TOAST_VARIANTS,
  BUTTON_SIZES,
  TextButton,
  Checkbox,
} from "cdk-radial";
import styled from "styled-components";
import { injectIntl, FormattedMessage, useIntl } from "react-intl";
import CommonLayout from "../CommonLayout";
import { useInjectReducer } from "../../utils/injectReducer";
import { RESEND_COUNTER_TIME } from "./constants";
import useLocaleMessages from "../../utils/localeMessage";

const PasscodeInput = styled(Input)`
  margin-top: 0.5em;
`;

const SubmitPrimaryButton = styled(PrimaryButton)`
  margin-top: 48px;
  width: 100%;
`;

const LoginCheckbox = styled(Checkbox)`
  margin-top: 0.25em;
  margin-bottom: 1em;
`;

const InfoText = styled(Content)`
  font-weight: normal;
  padding: 6px 0px;
`;

const PageTitle = styled(Heading)`
  padding: 8px 0px;
`;

const SubTitle = styled(Heading)`
  font-weight: 500;
  font-size: 20px;
`;

const ErrorToast = styled(Toast)`
  margin-bottom: 0.5em;
`;

const StyledDiv = styled.div`
  margin-top: 1.85em;
  margin-left: 2.5em;
  margin-right: 2.5em;
  text-align: center;
`;

const LinkButton = styled(TextButton)`
  font-weight: 500;
  color: #000000;
  &&:hover {
    background-color: #fff;
    color: #4d4d4d;
    text-decoration: underline;
  }
  &&:active {
    background-color: #fff;
    color: #4d4d4d;
    text-decoration: underline;
  }
`;

export function VerifyMfaFactor(props) {
  useInjectReducer({ key: "verifyMfaFactor", reducer });
  const dispatch = useDispatch();
  const intl = useIntl();
  const localeMessage = useLocaleMessages(intl);
  const selectedFactorResonse = useSelector((state) =>
    get(state, "mfaFactor.selectedMfaFactorResponse", {})
  );
  const selectedFactor = useSelector((state) =>
    get(state, "mfaFactor.selectedFactor", {})
  );
  const userGuid = useSelector((state) =>
    get(state, "loginPage.authnResponse._embedded.user.id", "")
  );
  const newAddedMfaFactor = useSelector((state) =>
    get(state, "enrollSpecificMFA.newAddedMfa", {})
  );

  const isActivateFactor =
    newAddedMfaFactor &&
    newAddedMfaFactor?.status === "PENDING_ACTIVATION" &&
    !Object.keys(selectedFactorResonse).length > 0;

  let getResendReq = () => {
    if (isActivateFactor) {
      return {
        factorType: newAddedMfaFactor?.factorType,
        provider: newAddedMfaFactor?.provider,
        profile: newAddedMfaFactor?.profile,
      };
    }
    return {
      factorType: selectedFactorResonse?.factorType,
      provider: selectedFactorResonse?.provider,
      profile: selectedFactorResonse?.profile,
    };
  };
  const email = localeMessage("MfaFactor.email.title");
  const phone = localeMessage("MfaFactor.phone.title");
  const type = newAddedMfaFactor?.factorType;
  const verificationSuccessToast = localeMessage(
    "VerifyPasscode.successMessage",
    { type: type === "email" ? email : phone }
  );

  const submitCliked = () => {
    if (isActivateFactor) {
      dispatch(submitPasscode(passcode, userGuid, newAddedMfaFactor?.id));
      dispatch(mfaSuccessMessage(verificationSuccessToast));
      return;
    }
    dispatch(
      passcodeSubmit(selectedFactor.id, rememberThisDevice, {
        stateToken: selectedFactorResonse.stateToken,
        passCode: passcode,
      })
    );
    dispatch(rememberDevice(rememberThisDevice));
  };
  const resendNewCode = () => {
    if (isActivateFactor) {
      dispatch(resendPasscode(userGuid, newAddedMfaFactor?.id, getResendReq()));
    } else {
      dispatch(
        resendCode(selectedFactor.id, rememberThisDevice, {
          stateToken: selectedFactorResonse.stateToken,
        })
      );
    }
    resetTimer();
  };
  const resetTimer = () => {
    setIntervalToResendCode(RESEND_COUNTER_TIME);
  };

  const errorMessage = useSelector((state) =>
    get(state, "verifyMfaFactor.errorMessage", "")
  );
  const successMessage = useSelector((state) =>
    get(state, "verifyMfaFactor.successMessage", "")
  );

  const isSuccess = useSelector((state) =>
    get(state, "verifyMfaFactor.isSuccess", false)
  );

  const isError = useSelector((state) =>
    get(state, "verifyMfaFactor.isError", false)
  );
  const isLoading = useSelector((state) =>
    get(state, "verifyMfaFactor.isLoading", false)
  );
  const isResendCodeLoading = useSelector((state) =>
    get(state, "verifyMfaFactor.isResendCodeLoading", false)
  );
   const isPasswordResetFlow = useSelector((state) =>
    get(state, "newPasswordPage.authnResponse.stateToken", "")
  );

  const [passcode, setPasscode] = useState("");
  const [rememberThisDevice, setRememberDevice] = useState(false);
  const [intervalToResendCode, setIntervalToResendCode] =
    useState(RESEND_COUNTER_TIME);
  useEffect(() => {
    let intervalId = setInterval(() => {
      if (intervalToResendCode > 0) {
        setIntervalToResendCode(intervalToResendCode - 1);
      }
      if (intervalToResendCode === 0) {
        clearInterval(intervalId);
      }
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [intervalToResendCode]);

  let contact = "";
  let contactNumber = " your contact";
  let factorType = selectedFactor.factorType || newAddedMfaFactor?.factorType;
  if (isEqual(factorType, "email")) {
    contact =
      selectedFactor?.profile?.email || newAddedMfaFactor?.profile?.email;
    contactNumber = contact;
  } else if (isEqual(factorType, "sms")) {
    contact =
      selectedFactor?.profile?.phoneNumber ||
      newAddedMfaFactor?.profile?.phoneNumber;
    contactNumber = `(...)...-${contact.slice(-4)}`;
  }

  const values = {
    contactNumber,
  };
  const infoTextvalue = props.intl.formatMessage(
    {
      id: "VerifyPasscode.infoText",
    },
    values
  );

  const isResendButtonDisabled =
    isResendCodeLoading || intervalToResendCode > 1;

  const resendButtonText = isResendButtonDisabled
    ? intl.formatMessage(
        {
          id: "VerifyPasscode.resendLinkText",
        },
        {
          interval: intervalToResendCode,
        }
      )
    : intl.formatMessage({
        id: "VerifyPasscode.resendLink",
    });
  
  const handleChange = (event) => {
    setRememberDevice(event.target.checked);
  };

  return (
    <CommonLayout>
      <CardContent>
        <PageTitle
          id="title"
          headingType={HEADING_TYPES.DISPLAY_3}
          level={HEADING_LEVELS.LEVEL_4}
        >
          <FormattedMessage id="MfaFactor.title" />
        </PageTitle>
        {isError && (
          <div>
            <ErrorToast
              content={errorMessage}
              variant={TOAST_VARIANTS.NEGATIVE}
            />
          </div>
        )}
        {isSuccess && (
          <div>
            <ErrorToast
              content={successMessage}
              variant={TOAST_VARIANTS.POSITIVE}
              visibilityDuration={3000}
            />
          </div>
        )}
        <SubTitle
          id="subTitle"
          headingType={HEADING_TYPES.HEADING_1}
          level={HEADING_LEVELS.LEVEL_1}
        >
          <FormattedMessage id="VerifyMfaFactor.subTitle" />
        </SubTitle>
        <InfoText tag="div" type="body-1">
          {infoTextvalue}
        </InfoText>
        {isActivateFactor && (
          <InfoText tag="div" type="body-1">
            <FormattedMessage id="VerifyPasscode.reAuthenticateInfoText" />
          </InfoText>
        )}
        <PasscodeInput
          id="passcode"
          label={<FormattedMessage id="VerifyPasscode.verification" />}
          maxLength="100"
          minLength="0"
          name="passcode"
          placeholder={intl.formatMessage({
            id: "VerifyPasscode.passcodeHint",
          })}
          size={INPUT_SIZES.STANDARD}
          type="text"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          isDisabled={isLoading}
        />
        {!isPasswordResetFlow ? (
          <LoginCheckbox
            id="remember-device-checkbox"
            label={<FormattedMessage id="VerifyPasscode.rememberDevice" />}
            labelPosition="after"
            name="remember-device"
            onChange={handleChange}
            indeterminate={false}
            dataTestId="checkbox"
            hideLabel={false}
            isDisabled={isLoading}
            checked={rememberThisDevice}
          />
        ) : (
          ""
        )}
        <SubmitPrimaryButton
          backgroundAppearance="light"
          dataTestId="primary-button"
          hideText={false}
          isDisabled={isLoading || !passcode}
          isLoading={isLoading}
          preserveClickableArea={false}
          text={intl.formatMessage({
            id: "Common.submit",
          })}
          size={BUTTON_SIZES.STANDARD}
          onClick={submitCliked}
        />
        <StyledDiv>
          <Content tag="div" type="body-1">
            <FormattedMessage id="VerifyPasscode.codeNotReceived" />
          </Content>
          <LinkButton
            id="resendNewCodeButton"
            backgroundAppearance="light"
            customTagElement=""
            hideText={false}
            iconClassName=""
            iconColor="primary"
            iconSize={24}
            isDisabled={isResendButtonDisabled}
            isLoading={isResendCodeLoading}
            onClick={resendNewCode}
            preserveClickableArea={false}
            size="standard"
            text={resendButtonText}
            type=""
          />
        </StyledDiv>
      </CardContent>
    </CommonLayout>
  );
}

export default withRouter(injectIntl(VerifyMfaFactor));
